export default __webpack_public_path__ + "static/media/motorbike_back_wheel.3552b383.png";